import 'swiper/css';
import 'swiper/css/lazy';
import Swiper, { Autoplay, Navigation } from 'swiper';
Swiper.use([Navigation, Autoplay]);
export class Carousel {
    el;
    carousel;
    swiper;
    columns;
    inset;
    constructor(el) {
        this.el = el;
        this.carousel = el.querySelector('.swiper');
        this.columns = el.hasAttribute('data-columns') ? el.getAttribute('data-columns') : '3';
        this.inset = el.hasAttribute('data-inset');
        this.init();
    }
    init() {
        if (this.carousel) {
            const defaultBreakpoints = {
                320: {
                    slidesPerView: 1.15,
                    spaceBetween: 16
                },
                400: {
                    slidesPerView: 1.1,
                    spaceBetween: 16
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 16
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 16
                },
                1366: {
                    slidesPerView: 3,
                    spaceBetween: 24
                },
                1600: {
                    slidesPerView: 3,
                    spaceBetween: 24
                }
            };
            let breakpointsObj = defaultBreakpoints;
            if (this.columns) {
                switch (this.columns) {
                    case '2':
                        breakpointsObj = Object.assign(defaultBreakpoints, {
                            768: {
                                slidesPerView: 2,
                                spaceBetween: 16
                            },
                            1024: {
                                slidesPerView: 2,
                                spaceBetween: 16
                            },
                            1366: {
                                slidesPerView: 2,
                                spaceBetween: 24
                            },
                            1600: {
                                slidesPerView: 2,
                                spaceBetween: 24
                            }
                        });
                        break;
                    case '4':
                        breakpointsObj = Object.assign(defaultBreakpoints, {
                            320: {
                                slidesPerView: 2,
                                spaceBetween: 16
                            },
                            400: {
                                slidesPerView: 2,
                                spaceBetween: 16
                            },
                            768: {
                                slidesPerView: 3,
                                spaceBetween: 16
                            },
                            1024: {
                                slidesPerView: 4,
                                spaceBetween: 16
                            },
                            1366: {
                                slidesPerView: 4,
                                spaceBetween: 24
                            },
                            1600: {
                                slidesPerView: 4,
                                spaceBetween: 24
                            }
                        });
                        break;
                    case '3/4':
                        breakpointsObj = Object.assign(defaultBreakpoints, {
                            768: {
                                slidesPerView: 1.3,
                                spaceBetween: 16
                            },
                            1024: {
                                slidesPerView: 1.33,
                                spaceBetween: 16
                            },
                            1366: {
                                slidesPerView: 1.33,
                                spaceBetween: 24
                            },
                            1600: {
                                slidesPerView: 1.33,
                                spaceBetween: 24
                            }
                        });
                        break;
                }
            }
            if (this.inset) {
                breakpointsObj = Object.assign(defaultBreakpoints, {
                    1024: {
                        slidesPerView: 2,
                        spaceBetween: 16
                    },
                    1366: {
                        slidesPerView: 2,
                        spaceBetween: 24
                    },
                    1600: {
                        slidesPerView: 2,
                        spaceBetween: 24
                    }
                });
            }
            this.swiper = new Swiper(this.carousel, {
                effect: 'slide',
                slidesPerView: 1.1,
                allowTouchMove: true,
                //autoplay: true,//
                // Disable preloading of all images
                preloadImages: false,
                lazy: {
                    loadPrevNext: true,
                },
                watchOverflow: true,
                watchSlidesProgress: true,
                navigation: {
                    nextEl: this.el.querySelector('.swiper-button-next'),
                    prevEl: this.el.querySelector('.swiper-button-prev'),
                },
                breakpoints: breakpointsObj
            });
        }
    }
}
